import React from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import CustomPagination from '../common/CustomPagination';
import NewReportButton from './NewReportButton';
import ReportStatus from './ReportStatus';
import { getReportNames } from '../../helpers/reports';

const ListReports = ({
  reports,
  pageIndex,
  pageSize,
  count,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const navigate = useNavigate();
  const timeFormat = 'MM/DD/YYYY hh:mma';
  const isEmpty = !reports || !reports.length;
  return (
    <>
      <Stack direction='row' justifyContent='flex-end' padding={1}>
        <NewReportButton />
      </Stack>
      <Paper sx={{padding: 2}}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Report Name</TableCell>
              <TableCell>Creator</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map(report => (
              <TableRow key={report.id}>
                <TableCell>
                  {getReportNames().find(r => r.key === report.report_name)?.name || report.report_name}
                </TableCell>
                <TableCell>{report?.creator?.user?.first_name} {report?.creator?.user?.last_name}</TableCell>
                <TableCell><ReportStatus report={report}/></TableCell>
                <TableCell>{moment(report.date_created).format(timeFormat)}</TableCell>
                <TableCell>
                  <Button
                    variant='text'
                    color={report.status === 'ERROR' ? 'error' : 'primary'}
                    disabled={report.status === 'GENERATING'}
                    onClick={e => navigate(`/admin/reports/view/${report.id}`)}
                  >
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {
          !isEmpty && count > 0 &&
          <Box sx={{marginTop: '0.625rem'}}>
            <CustomPagination
              pageSize={pageSize}
              pageIndex={pageIndex}
              count={count}
              onPageChange={onPageChange}
            />
          </Box>
        }
      </Paper>
    </>
  );
};

export default ListReports;